import { render, staticRenderFns } from "./CashbackRules.vue?vue&type=template&id=3deacc21&scoped=true"
var script = {}
import style0 from "./CashbackRules.vue?vue&type=style&index=0&id=3deacc21&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3deacc21",
  null
  
)

export default component.exports